<template>
  <header class="header">
    <nav
      :class="isSticky ? 'is-fixed-top' : ''"
      class="navbar main-nav is-dark-ben-franklin"
      role="navigation"
      aria-label="main navigation"
    >
      <div
        :class="{ 'is-fluid': fluid }"
        class="container"
      >
        <!-- Desktop header -->
        <div class="navbar-brand is-hidden-mobile is-hidden-touch">
          <div class="navbar-item">
            <a
              v-bind="appLogoLink"
              class="is-inline-block"
            >
              <img
                v-bind="appLogoImage"
              >
            </a>
          </div>
          <div class="navbar-item navbar-separator">
            <span />
          </div>
          <div
            class="navbar-item"
          >
            <a
              class="phl-app-title"
              :href="appLink"
            >
              <h1 class="is-size-5">
                {{ appTitle }}
              </h1>
              <h2
                v-if="appSubtitle"
                class="is-size-6"
              >{{ appSubtitle }}
              </h2>
            </a>
          </div>
        </div>

        <div class="navbar-menu is-hidden-mobile is-hidden-touch">
          <slot />
        </div>

        <!-- Navbar mobile -->
        <div class="navbar-mobile is-hidden-desktop">
          <div class="navbar-item phl-mobile-logo">
            <a href="#">
              <img v-bind="appMobileLogoImage" />
            </a>
          </div>
          <div class="navbar-item phl-mobile-title">
            <a
              :href="appLink"
            >
              <h1>
                {{ appTitle }}
              </h1>
              <h2
                v-if="appSubtitle"
              >{{ appSubtitle }}
              </h2>
            </a>
          </div>
          <!-- @slot The mobile-menu slot allows you to pass extra navigation for mobile usage -->
          <slot name="mobile-menu" />
        </div>
      </div>
    </nav>
  </header>
</template>
<script>
/**
 * This is the main application header.
 */
export default {
  name: 'AppHeader',
  props: {
    /**
     * The application logo. By default the City logo is used, however this could be used to display a department's logo.
    */
    appLogoImage: {
      type: Object,
      default: () => ({
        src: "https://standards.phila.gov/img/logo/city-of-philadelphia-yellow-white.png",
        alt: "City of Philadelphia logo",
        width: 170,
      }),
    },
    
    appMobileLogoImage: {
      type: Object,
      default: () => ({
        src: "https://www.phila.gov/assets/images/city-bell-yellow.png",
        alt: "City of Philadelphia logo",
      }),
    },
    /**
     * The logo link
    */
    appLogoLink: {
      type: Object,
      default: () => ({
        href: "https://www.phila.gov",
        target: "_blank",
      }),
    },
    /**
     * The application's title/name
    */
    appTitle: {
      type: String,
      default: "",
    },
    /**
     * The application's subtitle
    */
    appSubtitle: {
      type: String,
      default: "",
    },
    /**
     * The application's link. By default it links to the root.
    */
    appLink: {
      type: String,
      default: "/",
    },
    /**
     * Allows the header elements (logo, title, navigation...) to expand with the window width, or stay in the center
    */
    fluid: {
      type: Boolean,
      default: true,
    },
    /**
     * Sticks the header to the top of the page
    */
    isSticky: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped>
  .header .main-nav {
    border-bottom: 5px solid $electric-blue;
  }
  .navbar {
    // IE vertical align hack
    // height: 73px;
    min-height: 64px;
    .navbar-burger {
      span {
        height: 2px;
      }
    }
    h1, h2 {
      font-family: $family-secondary;
      font-weight: 500;
    }
    .navbar-separator {
      padding-left: 0;
      padding-right: 0;
      span {
        width: 1px;
        height: 45px;
        background: $white;
      }
    }
    .navbar-brand img {
      width: auto;
      height: 45px;
    }
    a.phl-app-title {
      color: inherit;
      &:hover {
        color: $electric-blue;
      }
      h1, h2 {
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
      }
      h1 {
        line-height: 1.5rem;
        font-size: 1.25rem;
      }
      h2 {
        line-height: 1.125rem;
        font-size: 0.875rem;
      }
    }
  }
  @include until(1024px) {
    .navbar {
      min-height: auto;
      border: none;
      .navbar-mobile {
        height: 56px;
        display: flex;
        align-items: stretch;
        justify-content: space-between;
        flex-flow: row nowrap;
        // padding: 0 8px;
        .navbar-item {
          align-items: center;
          display: flex;
          padding: 0;
          &.phl-mobile-logo {
            a {
              padding-right: 8px;
              padding-left: 8px;
              display: inline-block;
              line-height: 1;
              img {
                min-height: auto;
                height: 32px;
              }
            }
          }
          &.phl-mobile-title {
            flex-grow: 1;
            flex-shrink: 1;
            @include until(480px) {
              h2 {
                display: none;   
              }
            }
          }
          a {
            h1, h2 {
              line-height: 1.13;
            }
            h2 {
              font-size: 0.75rem;
              font-weight: normal;
              line-height: 1.08;
            }
            color: inherit;
          }
        }
      }
    }
  }
</style>